"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardControl = void 0;
var react_1 = require("react");
var getKeyCode_1 = require("../../../../utils/getKeyCode");
var useKeyboardControl = function (_a) {
    var showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, optionsWrapperRef = _a.optionsWrapperRef, handleSelect = _a.handleSelect, options = _a.options, searchString = _a.searchString, id = _a.id;
    var _b = (0, react_1.useState)(-1), focussedOp = _b[0], setFocussedOp = _b[1];
    // if search string is not empty, then reset focussedOp to first op
    // else set it to minus 1
    (0, react_1.useEffect)(function () {
        if ((searchString === null || searchString === void 0 ? void 0 : searchString.length) > 0)
            setFocussedOp(0);
        else if (focussedOp !== -1)
            setFocussedOp(-1);
    }, [searchString]);
    (0, react_1.useEffect)(function () {
        //update only when options are shut
        if (!showOptions)
            setFocussedOp(-1);
    }, [showOptions]);
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (e) {
            if (!showOptions)
                return;
            /**
             * dont prevent default outside the condition, else
             * all other key actions stop working..
             */
            var code = (0, getKeyCode_1.getKeyCode)(e);
            if (code === 'Enter') {
                if (options[focussedOp])
                    handleSelect(options[focussedOp]);
            }
            else if (code === 'ArrowDown') {
                if (showOptions)
                    e.preventDefault(); //basically disabled page scroll by arrow keys
                focussedOp !== options.length - 1 && setFocussedOp(function (p) { return p + 1; });
            }
            else if (code === 'ArrowUp') {
                if (showOptions)
                    e.preventDefault(); //basically disabled page scroll by arrow keys
                focussedOp !== -1 && setFocussedOp(function (p) { return p - 1; });
            }
            else if (code === 'Escape' /*esc*/) {
                handleHideOptions();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    });
    var scrollFocussedOpIntoView = function (el) {
        var _a = el.getBoundingClientRect(), elBottom = _a.bottom, elTop = _a.top;
        var _b = optionsWrapperRef.current.getBoundingClientRect(), opsWrapperBottom = _b.bottom, opsWrapperTop = _b.top;
        if (elBottom > opsWrapperBottom) {
            el.scrollIntoView({
                behaviour: 'smooth',
                block: 'nearest',
            });
        }
        else if (elTop < opsWrapperTop) {
            el.scrollIntoView({
                behaviour: 'smooth',
                block: 'nearest',
            });
        }
    };
    return {
        scrollFocussedOpIntoView: scrollFocussedOpIntoView,
        focussedOp: focussedOp
    };
};
exports.useKeyboardControl = useKeyboardControl;
